/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetReminderDetailQueryResponse,
  GetReminderDetailPathParams,
  GetReminderDetail400,
  GetReminderDetail404,
  GetReminderDetail500,
} from '../types/GetReminderDetail'

function getGetReminderDetailUrl({
  id,
}: {
  id: GetReminderDetailPathParams['id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/reminders/reminders/${id}/` as const,
  }
  return res
}

/**
 * @description Get detailed information about a specific reminder.
 * Delegates to GetReminderDetailUsecase for business logic.
 * @summary Get detail for a single reminder
 * {@link /api/v1/reminders/reminders/:id/}
 */
export async function getReminderDetail(
  { id }: { id: GetReminderDetailPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetReminderDetailQueryResponse,
    ResponseErrorConfig<
      GetReminderDetail400 | GetReminderDetail404 | GetReminderDetail500
    >,
    unknown
  >({
    method: 'GET',
    url: getGetReminderDetailUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
